"use strict";
import { __require as Z } from "./index.es508.js";
import { __require as F } from "./index.es524.js";
import { __require as ee } from "./index.es525.js";
import { __require as re } from "./index.es526.js";
import { __require as ne } from "./index.es527.js";
var k, A;
function fe() {
  if (A) return k;
  A = 1;
  var q = Z(), R = F(), b = /* @__PURE__ */ ee(), _ = /* @__PURE__ */ re(), N = /* @__PURE__ */ ne(), g = function() {
  };
  process.env.NODE_ENV !== "production" && (g = function(O) {
    var E = "Warning: " + O;
    typeof console < "u" && console.error(E);
    try {
      throw new Error(E);
    } catch {
    }
  });
  function x() {
    return null;
  }
  return k = function(O, E) {
    var P = typeof Symbol == "function" && Symbol.iterator, V = "@@iterator";
    function D(e) {
      var r = e && (P && e[P] || e[V]);
      if (typeof r == "function")
        return r;
    }
    var I = "<<anonymous>>", h = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: J(),
      arrayOf: W,
      element: z(),
      elementType: Y(),
      instanceOf: B,
      node: H(),
      objectOf: $,
      oneOf: U,
      oneOfType: G,
      shape: K,
      exact: L
    };
    function C(e, r) {
      return e === r ? e !== 0 || 1 / e === 1 / r : e !== e && r !== r;
    }
    function l(e, r) {
      this.message = e, this.data = r && typeof r == "object" ? r : {}, this.stack = "";
    }
    l.prototype = Error.prototype;
    function d(e) {
      if (process.env.NODE_ENV !== "production")
        var r = {}, i = 0;
      function o(u, t, a, f, c, p, s) {
        if (f = f || I, p = p || a, s !== b) {
          if (E) {
            var y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw y.name = "Invariant Violation", y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var j = f + ":" + a;
            !r[j] && // Avoid spamming the console because they are often not actionable except for lib authors
            i < 3 && (g(
              "You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + f + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), r[j] = !0, i++);
          }
        }
        return t[a] == null ? u ? t[a] === null ? new l("The " + c + " `" + p + "` is marked as required " + ("in `" + f + "`, but its value is `null`.")) : new l("The " + c + " `" + p + "` is marked as required in " + ("`" + f + "`, but its value is `undefined`.")) : null : e(t, a, f, c, p);
      }
      var n = o.bind(null, !1);
      return n.isRequired = o.bind(null, !0), n;
    }
    function v(e) {
      function r(i, o, n, u, t, a) {
        var f = i[o], c = m(f);
        if (c !== e) {
          var p = w(f);
          return new l(
            "Invalid " + u + " `" + t + "` of type " + ("`" + p + "` supplied to `" + n + "`, expected ") + ("`" + e + "`."),
            { expectedType: e }
          );
        }
        return null;
      }
      return d(r);
    }
    function J() {
      return d(x);
    }
    function W(e) {
      function r(i, o, n, u, t) {
        if (typeof e != "function")
          return new l("Property `" + t + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
        var a = i[o];
        if (!Array.isArray(a)) {
          var f = m(a);
          return new l("Invalid " + u + " `" + t + "` of type " + ("`" + f + "` supplied to `" + n + "`, expected an array."));
        }
        for (var c = 0; c < a.length; c++) {
          var p = e(a, c, n, u, t + "[" + c + "]", b);
          if (p instanceof Error)
            return p;
        }
        return null;
      }
      return d(r);
    }
    function z() {
      function e(r, i, o, n, u) {
        var t = r[i];
        if (!O(t)) {
          var a = m(t);
          return new l("Invalid " + n + " `" + u + "` of type " + ("`" + a + "` supplied to `" + o + "`, expected a single ReactElement."));
        }
        return null;
      }
      return d(e);
    }
    function Y() {
      function e(r, i, o, n, u) {
        var t = r[i];
        if (!q.isValidElementType(t)) {
          var a = m(t);
          return new l("Invalid " + n + " `" + u + "` of type " + ("`" + a + "` supplied to `" + o + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return d(e);
    }
    function B(e) {
      function r(i, o, n, u, t) {
        if (!(i[o] instanceof e)) {
          var a = e.name || I, f = X(i[o]);
          return new l("Invalid " + u + " `" + t + "` of type " + ("`" + f + "` supplied to `" + n + "`, expected ") + ("instance of `" + a + "`."));
        }
        return null;
      }
      return d(r);
    }
    function U(e) {
      if (!Array.isArray(e))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? g(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : g("Invalid argument supplied to oneOf, expected an array.")), x;
      function r(i, o, n, u, t) {
        for (var a = i[o], f = 0; f < e.length; f++)
          if (C(a, e[f]))
            return null;
        var c = JSON.stringify(e, function(p, s) {
          var y = w(s);
          return y === "symbol" ? String(s) : s;
        });
        return new l("Invalid " + u + " `" + t + "` of value `" + String(a) + "` " + ("supplied to `" + n + "`, expected one of " + c + "."));
      }
      return d(r);
    }
    function $(e) {
      function r(i, o, n, u, t) {
        if (typeof e != "function")
          return new l("Property `" + t + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
        var a = i[o], f = m(a);
        if (f !== "object")
          return new l("Invalid " + u + " `" + t + "` of type " + ("`" + f + "` supplied to `" + n + "`, expected an object."));
        for (var c in a)
          if (_(a, c)) {
            var p = e(a, c, n, u, t + "." + c, b);
            if (p instanceof Error)
              return p;
          }
        return null;
      }
      return d(r);
    }
    function G(e) {
      if (!Array.isArray(e))
        return process.env.NODE_ENV !== "production" && g("Invalid argument supplied to oneOfType, expected an instance of array."), x;
      for (var r = 0; r < e.length; r++) {
        var i = e[r];
        if (typeof i != "function")
          return g(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(i) + " at index " + r + "."
          ), x;
      }
      function o(n, u, t, a, f) {
        for (var c = [], p = 0; p < e.length; p++) {
          var s = e[p], y = s(n, u, t, a, f, b);
          if (y == null)
            return null;
          y.data && _(y.data, "expectedType") && c.push(y.data.expectedType);
        }
        var j = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
        return new l("Invalid " + a + " `" + f + "` supplied to " + ("`" + t + "`" + j + "."));
      }
      return d(o);
    }
    function H() {
      function e(r, i, o, n, u) {
        return T(r[i]) ? null : new l("Invalid " + n + " `" + u + "` supplied to " + ("`" + o + "`, expected a ReactNode."));
      }
      return d(e);
    }
    function S(e, r, i, o, n) {
      return new l(
        (e || "React class") + ": " + r + " type `" + i + "." + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + n + "`."
      );
    }
    function K(e) {
      function r(i, o, n, u, t) {
        var a = i[o], f = m(a);
        if (f !== "object")
          return new l("Invalid " + u + " `" + t + "` of type `" + f + "` " + ("supplied to `" + n + "`, expected `object`."));
        for (var c in e) {
          var p = e[c];
          if (typeof p != "function")
            return S(n, u, t, c, w(p));
          var s = p(a, c, n, u, t + "." + c, b);
          if (s)
            return s;
        }
        return null;
      }
      return d(r);
    }
    function L(e) {
      function r(i, o, n, u, t) {
        var a = i[o], f = m(a);
        if (f !== "object")
          return new l("Invalid " + u + " `" + t + "` of type `" + f + "` " + ("supplied to `" + n + "`, expected `object`."));
        var c = R({}, i[o], e);
        for (var p in c) {
          var s = e[p];
          if (_(e, p) && typeof s != "function")
            return S(n, u, t, p, w(s));
          if (!s)
            return new l(
              "Invalid " + u + " `" + t + "` key `" + p + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(i[o], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(e), null, "  ")
            );
          var y = s(a, p, n, u, t + "." + p, b);
          if (y)
            return y;
        }
        return null;
      }
      return d(r);
    }
    function T(e) {
      switch (typeof e) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !e;
        case "object":
          if (Array.isArray(e))
            return e.every(T);
          if (e === null || O(e))
            return !0;
          var r = D(e);
          if (r) {
            var i = r.call(e), o;
            if (r !== e.entries) {
              for (; !(o = i.next()).done; )
                if (!T(o.value))
                  return !1;
            } else
              for (; !(o = i.next()).done; ) {
                var n = o.value;
                if (n && !T(n[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(e, r) {
      return e === "symbol" ? !0 : r ? r["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && r instanceof Symbol : !1;
    }
    function m(e) {
      var r = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : M(r, e) ? "symbol" : r;
    }
    function w(e) {
      if (typeof e > "u" || e === null)
        return "" + e;
      var r = m(e);
      if (r === "object") {
        if (e instanceof Date)
          return "date";
        if (e instanceof RegExp)
          return "regexp";
      }
      return r;
    }
    function Q(e) {
      var r = w(e);
      switch (r) {
        case "array":
        case "object":
          return "an " + r;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + r;
        default:
          return r;
      }
    }
    function X(e) {
      return !e.constructor || !e.constructor.name ? I : e.constructor.name;
    }
    return h.checkPropTypes = N, h.resetWarningCache = N.resetWarningCache, h.PropTypes = h, h;
  }, k;
}
export {
  fe as __require
};
//# sourceMappingURL=index.es509.js.map
